<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>{{ $t('v4.ASSIGNED ACCOUNTS') }}</h4>
            </div>
        </div>
        <b-table-simple
            responsive
        >
            <b-thead>
                <b-tr>
                    <b-th>
                        {{ $t('v4.Month') }}
                    </b-th>
                    <b-th>
                        {{ $t('v4.Account') }}
                    </b-th>
                    <b-th class="text-right">
                        {{ $t('v4.Cost') }}
                    </b-th>
                    <b-th class="text-right">
                        {{ $t('v4.Paid') }}
                    </b-th>
                </b-tr>
            </b-thead>
            <b-tbody v-if="data.length">
                <b-tr v-for="(item, index) in newData" :key="index">
                    <b-td>
                        {{ item.month }}
                    </b-td>
                    <b-td>
                        <b>
                            <template v-if="!item.multi">
                                {{ item.usageAccountId }}
                            </template>
                            <template v-else>
                                {{ item.title }}
                            </template>
                        </b>
                        <br>
                        {{ item.projectName }}
                    </b-td>
                    <b-td class="text-right text-nowrap">
                        {{ item.currency === 'usd' ? $_getDollar(item.costKrw / 100) : $_getWon(item.costKrw) }} <br>
                        <small v-if="!item.multi">
                            ({{ item.dateAssigned }})
                        </small>
                    </b-td>
                    <b-td class="text-right text-nowrap">
                        <template v-if="item.datePaid">
                            <b>
                                {{ item.currency === 'usd' ? $_getDollar(item.costKrw / 100) : $_getWon(item.costKrw) }} <br>
                            </b>
                            <br>
                            <small>
                                ({{ item.datePaid }})
                            </small>
                        </template>
                        <template v-else>
                            <b-button
                                v-if="item.multi"
                                class="text-nowrap"
                                variant="warning"
                                @click="toMultiPay(item)"
                            >
                                <feather-icon icon="CreditCardIcon"/>
                                {{ $t('v4.Pay at once') }}
                            </b-button>
                            <b-button
                                v-else
                                class="text-nowrap"
                                variant="success"
                                @click="toSinglePay(item)"
                            >
                                <feather-icon icon="CreditCardIcon"/>
                                {{ $t('v4.Pay') }}
                            </b-button>
                        </template>
                    </b-td>
                </b-tr>
            </b-tbody>
            <b-tbody v-else>
                <b-tr>
                    <b-td colspan="4" class="text-center">
                        <div class="pt-2">
                            {{ $t('org.message.There are no usage details') }}
                        </div>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </b-card>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    computed: {
        newData () {
            if (!this.data.length) return []
            const list = []
            let currnetMonth = this.data[0].month
            let currentMonthCount = 0
            let currentMonthCost = 0
            let assignedIdxs = []
            let projectIdxs = []
            this.data.forEach(item => {
                if (currnetMonth !== item.month) {
                    if (currnetMonth !== '' && currentMonthCount > 1) {
                        list.push({
                            month: currnetMonth,
                            usageAccountId: null,
                            multi: true,
                            title: `${currentMonthCount} AWS Accounts`,
                            costKrw: currentMonthCost,
                            assignedIdxs,
                            projectIdxs
                        })
                    }
                    currnetMonth = item.month

                    if (!item.costPaid && item.currency === 'krw') {
                        currentMonthCount = 1
                        currentMonthCost = item.costKrw
                        assignedIdxs = [item.idx]
                    } else {
                        currentMonthCount = 0
                        currentMonthCost = 0
                        assignedIdxs = []
                    }
                } else {
                    if (!item.costPaid && item.currency === 'krw') {
                        currentMonthCount++
                        currentMonthCost += item.costKrw
                        assignedIdxs.push(item.idx)
                        projectIdxs.push(item.projectIdx)
                    }
                }
                list.push(item)
            })
            return list
        }
    },
    methods: {
        toMultiPay ({ projectIdxs, assignedIdxs }) {
            this.$emit('next:page', { projectIdxs, assignedIdxs })
        },
        toSinglePay ({ projectIdx, idx }) {
            this.$emit('next:page', { projectIdxs: [projectIdx], assignedIdxs: [idx] })
        }
    }
}
</script>

<style>

</style>
